<ion-content #contentWrapper [class.web]="isWeb()" [scrollEvents]="true" (ionScroll)="onScroll($any($event))">
  @if (!isWeb()) {
    <app-panel background="faded" [padded]="false">
      <app-slides />
    </app-panel>
    @if (hasActiveOrders() || (hasPrograms() && !hasActiveProgramOrders())) {
      <app-panel background="faded" [padded]="true">
        <app-order-wrapper />
        @if (hasPrograms() && !hasActiveProgramOrders()) {
          <app-program-wrapper />
        }
      </app-panel>
    }
    <app-panel background="faded" [contentHeader]="isLoggedIn() ? 'Delivery Details' : undefined">
      @if (isLoggedIn()) {
        @if (placeDetails()) {
          <app-address-details [canEdit]="true" (editAddressEvent)="editAddress()" (editNotesEvent)="editDeliveryNotes()" [placeDetails]="placeDetails()!" />
        } @else {
          <app-button (click)="editAddress()" label="Set Address" size="large" />
        }
        @if (deliveryMethod()) {
          <app-delivery-method-option [pharmacyAddress]="pharmacyAddress()" [customerAddress]="placeDetails()" (click)="setDeliveryMethod()" [fullFillmentMethod]="deliveryMethod()" [isSelectable]="false" />
        }
      } @else {
        <app-button class="mb-16" (click)="signUp()" label="Sign Up" size="large" [bold]="true" iconRight="arrow-forward-outline" color="white" bgColor="primary"></app-button>
        <app-button (click)="logIn()" label="Login" color="secondary" bgColor="white"></app-button>
      }
    </app-panel>
    <app-panel class="gap" background="faded"></app-panel>
    <app-panel background="transparent" contentHeader="Prescriptions" headerSize="medium">
      <div class="row">
        <app-script-button [enabled]="isLoggedIn()" (actionClick)="addScript()" />
      </div>
    </app-panel>
    <app-panel class="gap" background="faded"></app-panel>
    <app-panel background="faded" [padded]="false" contentHeader="Non-Prescription Products" action="View all" (actionClick)="viewAllCategories()" headerSize="medium">
      <div class="row categories">
        @for (category of categories(); track category.id) {
          <app-category-button-small (click)="goToCategory(category.id)" [data]="category" />
        }
      </div>
    </app-panel>
    <app-panel background="faded" [padded]="false" contentHeader="Popular Products">
      <app-product-scroller />
    </app-panel>
  } @else {
    <div class="web-banner-container">
      <div>
        @if (activeOrders().length < 2) {
          <app-slides [large]="!hasActiveOrders() && !(hasPrograms() && !hasActiveProgramOrders())" />
        }
        @if (hasActiveOrders() || (hasPrograms() && !hasActiveProgramOrders())) {
          <app-panel background="transparent" [padded]="true">
            <app-order-wrapper />
            @if (hasPrograms() && !hasActiveProgramOrders()) {
              <app-program-wrapper />
            }
          </app-panel>
        }
      </div>
      <div class="script-btn-wrapper">
        <app-script-button mode="web" style="width: 100%;" [enabled]="isLoggedIn()" (actionClick)="addScript()" />
      </div>
    </div>
    <app-panel [large]="true" background="transparent" [padded]="false" contentHeader="Non-Prescription Products" action="View all" (actionClick)="viewAllCategories()" headerSize="medium">
      <div class="row categories">
        @for (category of categories(); track category.id) {
          <app-category-button-small (click)="goToCategory(category.id)" [data]="category" />
        }
      </div>
    </app-panel>
    <app-panel [large]="true" background="transparent" [padded]="false" contentHeader="Popular Products">
      <app-product-scroller />
    </app-panel>
  }
  @if (showToTop()) {
    <app-fab (click)="goToTop()" />
  }
</ion-content>